const VIDEO_EXTENSIONS = new Set([
  '.3gp',
  '.asf',
  '.avi',
  '.f4v',
  '.flv',
  '.m2ts',
  '.m4v',
  '.mkv',
  '.mov',
  '.mp4',
  '.mpeg',
  '.mpg',
  '.mts',
  '.ogv',
  '.ts',
  '.vob',
  '.webm',
  '.wmv',
]);

export const isVideoFile = (filePath: string | undefined | null): boolean => {
  if (typeof filePath !== 'string') return false;
  const extension = filePath.toLowerCase().match(/\.[^./\\?#]+(?=$|[?#])/)?.[0];
  return extension ? VIDEO_EXTENSIONS.has(extension) : false;
};

export const toPlayableMediaUrl = (filePath: string): string => {
  if (/^(file|https?|blob|data):/i.test(filePath)) return filePath;
  const normalized = filePath.replace(/\\/g, '/').replace(/^([^/])/, '/$1');
  return `file://${encodeURI(normalized)}`;
};
